var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 5a2 2 0 1 0-4 0m9.26 4.696 1.385 9A1.998 1.998 0 0 1 18.67 21H5.33a2 2 0 0 1-1.977-2.304l1.385-9A2 2 0 0 1 6.716 8h10.568a2 2 0 0 1 1.976 1.696z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cart.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Cart;

Cart.default = Cart;
